// SEO data configuration for all pages
export const SEO_DATA = {
  '/': {
    title: 'Prime Markets - Premium Trading Platform',
    description: 'Trade Forex, Stocks, Indices, Commodities and Crypto with Prime Markets. Professional trading platform with competitive spreads, advanced tools, and expert support in South Africa.',
    keywords: 'forex trading, stocks, CFD trading, commodities, crypto trading, trading platform, Prime Markets, South Africa, online trading',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "FinancialService",
      "name": "Prime Markets",
      "description": "Premium trading platform offering Forex, Stocks, Indices, Commodities and Crypto trading",
      "url": "https://primemarkets.co.za",
      "logo": "https://factsheets.digitallandscape.co.za/site/images/PrimeMarkets-premium-trading.png",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "ZA",
        "addressRegion": "KwaZulu-Natal",
        "addressLocality": "Durban"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+27104464170",
        "contactType": "customer service"
      },
      "sameAs": [
        "https://www.facebook.com/primemarkets",
        "https://www.twitter.com/primemarkets"
      ]
    }
  },
  '/forex': {
    title: 'Forex Trading',
    description: 'Trade major, minor and exotic currency pairs with Prime Markets. Competitive spreads, advanced charts, and expert analysis for successful forex trading.',
    keywords: 'forex trading, currency pairs, EUR/USD, GBP/USD, forex broker, currency trading, Prime Markets forex',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Forex Trading",
      "provider": {
        "@type": "FinancialService",
        "name": "Prime Markets"
      },
      "description": "Professional forex trading services with competitive spreads and advanced trading tools"
    }
  },
  '/stocks': {
    title: 'Stock Trading',
    description: 'Trade global stocks and shares with Prime Markets. Access to major exchanges, real-time data, and professional trading tools for stock market success.',
    keywords: 'stock trading, shares, equity trading, stock market, NYSE, NASDAQ, JSE, Prime Markets stocks',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Stock Trading",
      "provider": {
        "@type": "FinancialService",
        "name": "Prime Markets"
      },
      "description": "Trade global stocks with access to major exchanges and real-time market data"
    }
  },
  '/indices': {
    title: 'Index Trading',
    description: 'Trade major global indices including S&P 500, FTSE 100, DAX, and Nikkei with Prime Markets. Diversify your portfolio with index CFDs.',
    keywords: 'index trading, indices, S&P 500, FTSE 100, DAX, Nikkei, market indices, Prime Markets indices',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Index Trading",
      "provider": {
        "@type": "FinancialService",
        "name": "Prime Markets"
      },
      "description": "Trade major global market indices with competitive spreads and leverage"
    }
  },
  '/commodities': {
    title: 'Commodity Trading',
    description: 'Trade gold, oil, silver, and other commodities with Prime Markets. Access global commodity markets with competitive pricing and expert support.',
    keywords: 'commodity trading, gold, oil, silver, precious metals, energy commodities, Prime Markets commodities',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Commodity Trading",
      "provider": {
        "@type": "FinancialService",
        "name": "Prime Markets"
      },
      "description": "Trade precious metals, energy, and agricultural commodities with competitive spreads"
    }
  },
  '/crypto': {
    title: 'Cryptocurrency Trading',
    description: 'Trade Bitcoin, Ethereum, and other cryptocurrencies with Prime Markets. Secure crypto trading platform with competitive spreads and advanced tools.',
    keywords: 'cryptocurrency trading, Bitcoin, Ethereum, crypto, digital currency, Prime Markets crypto',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Cryptocurrency Trading",
      "provider": {
        "@type": "FinancialService",
        "name": "Prime Markets"
      },
      "description": "Trade major cryptocurrencies including Bitcoin and Ethereum with secure platform"
    }
  },
  '/cfd-trading': {
    title: 'CFD Trading',
    description: 'Contract for Difference (CFD) trading with Prime Markets. Trade CFDs on forex, stocks, indices, and commodities with flexible leverage.',
    keywords: 'CFD trading, contract for difference, leveraged trading, CFD broker, Prime Markets CFDs',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "CFD Trading",
      "provider": {
        "@type": "FinancialService",
        "name": "Prime Markets"
      },
      "description": "Professional CFD trading services with flexible leverage and competitive spreads"
    }
  },
  '/accounts': {
    title: 'Trading Accounts',
    description: 'Choose from individual, joint, Islamic, demo, and corporate trading accounts with Prime Markets. Find the perfect account type for your trading needs.',
    keywords: 'trading accounts, demo account, Islamic account, corporate account, Prime Markets accounts',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Trading Accounts",
      "provider": {
        "@type": "FinancialService",
        "name": "Prime Markets"
      },
      "description": "Various trading account types to suit different trading needs and preferences"
    }
  },
  '/about-prime-markets': {
    title: 'About Prime Markets',
    description: 'Learn about Prime Markets - South Africa\'s premium trading platform. Our mission, values, and commitment to providing exceptional trading services.',
    keywords: 'about Prime Markets, company info, trading platform, South Africa broker, financial services',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "mainEntity": {
        "@type": "FinancialService",
        "name": "Prime Markets",
        "description": "Premium trading platform based in South Africa"
      }
    }
  },
  '/news': {
    title: 'Market News & Analysis',
    description: 'Stay updated with the latest market news, analysis, and insights from Prime Markets. Expert commentary on forex, stocks, and global markets.',
    keywords: 'market news, trading analysis, financial news, market insights, Prime Markets news',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      "publisher": {
        "@type": "FinancialService",
        "name": "Prime Markets"
      }
    }
  },
  '/economic-calendar': {
    title: 'Economic Calendar',
    description: 'Track important economic events and announcements with Prime Markets economic calendar. Stay ahead of market-moving news and data releases.',
    keywords: 'economic calendar, economic events, market news, financial calendar, Prime Markets calendar',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Economic Calendar",
      "description": "Track important economic events and market-moving announcements"
    }
  }
};

// Function to get SEO data for a specific route
export const getSEOData = (pathname) => {
  return SEO_DATA[pathname] || {
    title: 'Prime Markets',
    description: 'Trade with Prime Markets - Your premium trading platform for forex, stocks, indices, commodities and crypto.',
    keywords: 'Prime Markets, trading platform, forex, stocks, CFDs'
  };
};